import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { labs, patients } from "lobbie";

export interface ILabsOrderDrawerState {
    show: boolean;
    onCloseDrawer?: (canceled: boolean) => void;
    accountPatient?: patients.IAccountPatient;
    appointmentId?: number;
    labVendors?: labs.ILabVendor[];
    isManual?: boolean;
}

export const initialStateLabsOrderDrawer: ILabsOrderDrawerState = {
    show: false,
    accountPatient: undefined,
    appointmentId: undefined,
    labVendors: undefined,
    onCloseDrawer: undefined,
    isManual: true,
};

const labsOrderDrawerSlice = createSlice({
    name: "labsOrderDrawer",
    initialState: initialStateLabsOrderDrawer,
    reducers: {
        showLabsOrderDrawer: (
            _state,
            action: PayloadAction<Omit<ILabsOrderDrawerState, "show">>,
        ) => {
            return {
                ...action.payload,
                show: true,
            };
        },
        hideLabsOrderDrawer: (state) => {
            return {
                ...state,
                accountPatient: undefined,
                appointmentId: undefined,
                labVendors: undefined,
                isManual: true,
                onCloseDrawer: undefined,
                show: false,
            };
        },
    },
});

export const { showLabsOrderDrawer, hideLabsOrderDrawer } = labsOrderDrawerSlice.actions;
export default labsOrderDrawerSlice.reducer;
